export default __webpack_public_path__ + "static/women1-126b1274b08b898fd64509f532766aa5.webp";